<template>
    <Breadcrumbs main="Form Controls" title="Mega Options" />
    <div class="container-fluid">
        <div class="row">
            <variationRadio />
            <variationCheckbox />
            <defultStyle />
            <borderStyle />
            <solidBorder />
            <offerBorder />
            <inlineStyle />
            <verticalStyle />
            <horizontalStyle />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const variationRadio = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/variationRadio.vue"))
const variationCheckbox = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/variationCheckbox.vue"))
const defultStyle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/defultStyle.vue"))
const borderStyle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/borderStyle.vue"))
const solidBorder = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/solidBorder.vue"))
const offerBorder = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/offerBorder.vue"))
const inlineStyle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/inlineStyle.vue"))
const verticalStyle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/verticalStyle.vue"))
const horizontalStyle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/horizontalStyle.vue"))
</script>